import { render, staticRenderFns } from "./TherapistCTA.vue?vue&type=template&id=1604a3d7&scoped=true"
import script from "./TherapistCTA.vue?vue&type=script&lang=js"
export * from "./TherapistCTA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1604a3d7",
  null
  
)

export default component.exports